<div class="container w-full ps-9">
    <form [formGroup]="filtersEditFrom" (ngSubmit)="onSubmit()" class="pt-8">
        <div class="flex flex-col gap-x-8 gap-y-2 m-auto justify-center items-start w-full">
            <mat-form-field appearance="outline" class="w-1/3">
                <mat-label>Cambio de contraseña</mat-label>
                <input
                    matInput
					[type]="showPassword.old ? 'text' : 'password'"
					formControlName="old"
					placeholder="Contraseña Actual"
				/>
                <button
                    mat-icon-button
                    matSuffix
                    (mousedown)="togglePasswordVisibility('old', true)"
                    (mouseup)="togglePasswordVisibility('old', false)"
                    (mouseleave)="togglePasswordVisibility('old', false)">
                    <mat-icon>{{ showPassword.old ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-1/3">
                <mat-label>Cambio de contraseña</mat-label>
                <input
                    matInput
					[type]="showPassword.new ? 'text' : 'password'"
					formControlName="new"
					placeholder="Nueva contraseña"
				/>
                <button
                    mat-icon-button
                    matSuffix
                    (mousedown)="togglePasswordVisibility('new', true)"
                    (mouseup)="togglePasswordVisibility('new', false)"
                    (mouseleave)="togglePasswordVisibility('new', false)">
                    <mat-icon>{{ showPassword.new ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-1/3">
                <mat-label>Cambio de contraseña</mat-label>
                <input
                    matInput
					[type]="showPassword.reit ? 'text' : 'password'"
					formControlName="reit"
					placeholder="Reitera tu nueva contraseña"
				/>
                <button
                    mat-icon-button
                    matSuffix
                    (mousedown)="togglePasswordVisibility('reit', true)"
                    (mouseup)="togglePasswordVisibility('reit', false)"
                    (mouseleave)="togglePasswordVisibility('reit', false)">
                    <mat-icon>{{ showPassword.reit ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
            </mat-form-field>

            <button
                mat-raised-button
                color="primary"
                type="submit"
                class="guardar-cambios-btn"
                [disabled]="filtersEditFrom.invalid">
                Guardar Cambios
            </button>
        </div>
    </form>
</div>